export default __webpack_public_path__ + "static/media/logo-new-2.e0bcebd9.png";